<template>
  <div class="container mt-4">
    <div class="card">
      <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
        <h4 class="mb-0">User Management</h4>
        <button class="btn btn-light" @click="openCreateModal('createModal')">
          Add New User
        </button>
        <button class="btn btn-light" @click="openCreateModal('secondModal')">
          Add Second Modal
        </button>
      </div>
      
      <div class="card-body">
        <!-- Modal with CreateUser inside slot -->
        <FormModal ref="createModal" title="Create New User" id="create_user_form_modal">
          <CreateUser 
            ref="createUserForm"
            @created="onUserCreated"
            @close="closeCreateModal('createModal')"
          />
        </FormModal>

         <FormModal ref="secondModal" title="Second Modal" id="second_form_modal">
          <CreateUser 
            ref="secondForm"
            @created="onUserCreated"
            @close="closeCreateModal('secondModal')"
          />
        </FormModal>

        <!-- Loading State -->
        <LoadingBar v-if="loading" message="Loading Users..." />

        <!-- Users Table -->
        <div v-else class="table-responsive">
          <table class="table table-bordered table-hover">
            <thead class="table-light">
              <tr>
                <th>External ID</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Photo</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in users" :key="user.external_id">
                <td>{{ user.external_id }}</td>
                <td>{{ user.first_name }}</td>
                <td>{{ user.last_name }}</td>
                <td>{{ user.email }}</td>
                <td>{{ user.phone }}</td>
                <td class="text-center">
                  <img 
                    v-if="user.photo" 
                    :src="user.photo" 
                    width="40" 
                    height="40" 
                    class="rounded-circle"
                  >
                  <span v-else class="text-muted">No Photo</span>
                </td>
              </tr>
              <tr v-if="users.length === 0">
                <td colspan="6" class="text-center">No users found</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <Pagination 
          :pagination="pagination"
          @page-change="changePage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { form_api_submit } from '@/utils/FormSubmit'
import Pagination from '@/components/utils/PaginationBar.vue'
import LoadingBar from '@/components/utils/LoadingBar.vue'
import FormModal from '@/components/utils/FormModal.vue'
import CreateUser from '@/views/User/CreateUser.vue'

export default {
  name: 'ListTest',
  components: { 
    Pagination, 
    LoadingBar,
    FormModal,
    CreateUser
  },
  data() {
    return {
      users: [],
      pagination: {
        total_rows: 0,
        per_page: 20,
        current_page: 1,
        total_pages: 1
      },
      loading: false
    }
  },
  mounted() {
    // alert(localStorage.getItem('user_token'));
    this.fetchUsers()
  },
  methods: {
    openCreateModal(ref) {
      this.$refs[ref].showModal()
    },
    
    closeCreateModal(ref) {
      this.$refs[ref].closeModal()
    },
    
    async onUserCreated() {
      this.pagination.current_page = 1
      await this.fetchUsers()
    },
    
    async fetchUsers() {
      this.loading = true
      
      const result = await form_api_submit({
        url: 'list',
        method: 'POST',
        data: {
          page: this.pagination.current_page,
        },
        show_success_toast: false,
        show_error_toast: true
      })
      
      if (result.success) {
        console.log(result);
        this.users = result.data.list
        this.pagination = result.data.pagination
      }
      
      this.loading = false
    },
    
    changePage(page) {
      if (page < 1 || page > this.pagination.total_pages) return
      this.pagination.current_page = page
      this.fetchUsers()
    }
  }
}
</script>

<style scoped>
.card-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.table th {
  background-color: #f8f9fa;
  font-weight: 600;
}

.page-link {
  cursor: pointer;
}

.page-item.active .page-link {
  background-color: #667eea;
  border-color: #667eea;
}

img {
  object-fit: cover;
}
</style>